import { KYMW9009Model } from '../kymw9009.model';
import { GetOktaUserNameModel } from '../vo/get-okta-user-name.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';

/**
 * Okta情報ユーザ名取得コマンド
 * サーバーにOkta情報ユーザ名をリクエストし、結果を表示する。
 *
 * @export GetOktaUserNameService
 * @class GetOktaUserNameService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetOktaUserNameService extends PlessJsonResponderSub<any> {
  private model: KYMW9009Model = null;
  private vo: GetOktaUserNameModel = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetOktaUserNameService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        GetOktaUserName: {
          condition: {
            UserId: this.vo.UserId,
          }
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW9009Model} model モデルクラス
   * @param {GetOktaUserNameModel} vo Oktaユーザ名取得条件VO
   * @memberof GetOktaUserNameService
   */
  execute(model: KYMW9009Model, vo: GetOktaUserNameModel) {
    this.model = model;
    this.vo = vo;
    this.send('getOktaUserName', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetOktaUserNameService
   */
  success(data: any) {
    // ユーザ名を更新
    this.model.updateUserName(data, this.vo);
  }
}
